import React from 'react';
import { Card, Accordion} from 'react-bootstrap';
import NumberToPersianWord from "number_to_persian_word";
import { NumToFa} from "../../Functions/TextTransform";


export default function Step4Pleated({
  setStep5,
 ContextAwareToggle,
 t,
 pageLanguage,
 stepSelectedLabel,
 requiredStep,
 step3A0,
 step3,
 modalHandleShow,
 setMountTypeTemp,
 setStep3A0,
 setStep3,
 setDepth,
 setMouldingHeight,
 setMountErr1,
 setMountErr2,
 setDeps,
 setCart,
 setCartLoading,
 setMeasurementsNextStep,
 setExtendedTitle,
 clearInputs,
 extendedTitle,
 inputs,
 depthHelp,
 setDepthHelp,
 selectChanged,
 depth,
 mountErr1,
 mountErr2,
 mouldingHeight,
 ContextAwareToggleViewDetails,
 NextStep,
}) {
  return (
   <Card>
   <Card.Header>
     <ContextAwareToggle
       eventKey="3A0"
       stepNum={t("4")}
       stepTitle={t("zebra_step2")}
       stepRef="3A0"
       type="1"
       required={requiredStep["3A0"]}
       stepSelected={
         stepSelectedLabel["3A0"] === undefined ? "" : stepSelectedLabel["3A0"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="3A0">
     <Card.Body>
       <div className="card_body card_body_radio card_body_radio_camera card_body_radio_medium_img">
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/europeanNew/mounttype-wall.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Wall")}
             value="1"
             name="step3A0"
             ref-num="3A0"
             id="3A01"
             checked={step3A0 === "Wall"}
             onChange={(e) => {
               setStep5("");
               if (step3A0 !== "" && step3 !== "") {
                 modalHandleShow("MountTypeWarning");
                 setMountTypeTemp({
                   stepValue: "Wall",
                   id: "",
                   cartValue: "Wall",
                   event: e,
                 });
               } else {
                 setStep3A0("Wall");
                 setStep3("");
                 setStep5("");
                 setDepth(undefined);
                 setMouldingHeight(undefined);
                 setMountErr1(false);
                 setMountErr2(false);
                 setDeps(
                   "3,311,312",
                   "3A0,3A11,3A12,31,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3ARod,3ARod1,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,3BRodHaveRod,3CRodFloorHaveRod,3DRod,3CRodIHave"
                 );
                 setCart(
                   "Mount",
                   "Wall",
                   "Depth,MouldingHeight,calcMeasurements,Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                 );
                 clearInputs(e, undefined, "3,3A,3B");
                 setMeasurementsNextStep("4");
               }
               let tempExtended = extendedTitle;
               tempExtended["3A0"] = [];
               setExtendedTitle(tempExtended);
             }}
             ref={(ref) => (inputs.current["3A01"] = ref)}
           />
           <label htmlFor="3A01">{t("Wall")}</label>
         </div>
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/europeanNew/mounttype-ceilling.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Ceiling")}
             value="2"
             name="step3A0"
             ref-num="3A0"
             id="3A02"
             checked={step3A0 === "Ceiling"}
             onChange={(e) => {
               setStep5("");
               if (step3A0 !== "" && step3 !== "") {
                 modalHandleShow("MountTypeWarning");
                 setMountTypeTemp({
                   stepValue: "Ceiling",
                   id: "",
                   cartValue: "Ceiling",
                   event: e,
                 });
               } else {
                 setStep3A0("Ceiling");
                 setStep3("");
                 setStep5("");
                 setDepth(undefined);
                 setMouldingHeight(undefined);
                 setMountErr1(false);
                 setMountErr2(false);
                 setDeps(
                   "3,311,312",
                   '3A0,,3BRodHaveRod,3CRodFloorHaveRod,3DRod,3CRodIHave,3A11,3A12,31,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3ARod,3ARod1,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3");'
                 );
                 setCart(
                   "Mount",
                   "Ceiling",
                   "Depth,MouldingHeight,calcMeasurements,Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                 );
                 clearInputs(e, undefined, "3,3A,3B");
                 setMeasurementsNextStep("4");
               }
               let tempExtended = extendedTitle;
               tempExtended["3A0"] = [];
               setExtendedTitle(tempExtended);
             }}
             ref={(ref) => (inputs.current["3A02"] = ref)}
           />
           <label htmlFor="3A02">{t("Ceiling")}</label>
         </div>
         <div className="box33 radio_style">
           <img
             src={require("../../Images/drapery/europeanNew/mounttype-moulding.svg").default}
             className="img-fluid"
             alt=""
           />
           <input
             className="radio"
             type="radio"
             text={t("Moulding")}
             value="3"
             name="step3A0"
             ref-num="3A0"
             id="3A03"
             checked={step3A0 === "Moulding"}
             onChange={(e) => {
               setStep5("");
               if (step3A0 !== "" && step3 !== "") {
                 modalHandleShow("MountTypeWarning");
                 setMountTypeTemp({
                   stepValue: "Moulding",
                   id: "",
                   cartValue: "Moulding",
                   event: e,
                 });
               } else {
                 setStep3A0("Moulding");
                 setStep3("");
                 setStep5("");
                 setDepth(undefined);
                 setMouldingHeight(undefined);
                 setDeps(
                   "3,3A11,3A12",
                   '3A0,,3BRodHaveRod,3CRodFloorHaveRod,3DRod,3CRodIHave,31,311,312,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3ARod,3ARod1,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3");'
                 );
                 setCart(
                   "Mount",
                   "Moulding",
                   "calcMeasurements,Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                 );
                 clearInputs(e, undefined, "3,3A0,3A,3B");
                 setMeasurementsNextStep("4");
               }
             }}
             ref={(ref) => (inputs.current["3A03"] = ref)}
           />
           <label htmlFor="3A03">{t("mount_MouldingMount")}</label>
         </div>

         <div
           className={
             step3A0 === "Moulding" ? "own_measurements_container" : "noDisplay"
           }
         >
           <div className="own_measurements_width">
             <div className="measure_input_container">
               <h1 className="measure_input_label">{t("Depth")}</h1>
               <div className="measure_input_field_container">
                 <input
                   ref={(ref) => (inputs.current["depth"] = ref)}
                   autoComplete="off"
                   onKeyDown={(e) => {
                     if (e.keyCode === 13) {
                       inputs.current["mouldingHeight"].focus();
                     } else if (
                       !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                       e.keyCode !== 8 &&
                       e.keyCode !== 46 &&
                       e.keyCode !== 37 &&
                       e.keyCode !== 39 &&
                       e.keyCode !== 13
                     ) {
                       e.preventDefault();
                     }
                   }}
                   className={
                     "measure_input" +
                     ((depth !== undefined && (depth < 1 || depth > 1000)) || mountErr1
                       ? " measure_input_err"
                       : "")
                   }
                   type="text"
                   name="depth"
                   value={NumToFa(`${depth || ""}`, pageLanguage)}
                   text={t("Moulding")}
                   ref-num="3A0"
                   onChange={(e) => {
                     let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                     setDepth(parseInt(newValue));
                     setTimeout(() => {
                       if (
                         newValue &&
                         newValue !== "" &&
                         parseInt(newValue) >= 1 &&
                         parseInt(newValue) <= 1000
                       ) {
                         setCartLoading(true);
                         setCart("Depth", parseInt(newValue));
                         setDeps("", "3A11");
                         setMountErr1(false);
                         if (
                           mouldingHeight &&
                           mouldingHeight !== "" &&
                           parseInt(mouldingHeight) >= 1 &&
                           parseInt(mouldingHeight) <= 40
                         ) {
                           selectChanged(e);
                           let tempExtended = extendedTitle;
                           tempExtended["3A0"] = [e.target.getAttribute("text")];
                           tempExtended["3A0"][1] = (
                             <li key="1" className="step_title_extended_list_item">
                               <span className="step_title_extended_list_item_title">
                                 {t("Depth")}: {parseInt(newValue)}
                                 {t("cm_label")}
                               </span>
                               <span className="step_title_extended_list_item_text">
                                 {t("MouldingHeight")}: {parseInt(mouldingHeight)}
                                 {t("cm_label")}
                               </span>
                             </li>
                           );
                           setExtendedTitle(tempExtended);
                         } else {
                           selectChanged(undefined, "3A0");
                           let tempExtended = extendedTitle;
                           tempExtended["3A0"] = [];
                           setExtendedTitle(tempExtended);
                         }
                       } else {
                         setCartLoading(true);
                         selectChanged("3A0", undefined, t("Invalid Measurements"));

                         setCart("", "", "Depth");
                         setDeps("3A11", "");
                         let tempExtended = extendedTitle;
                         tempExtended["3A0"] = [];
                         setExtendedTitle(tempExtended);
                       }
                     }, 200);
                   }}
                 />
                 <div className="measure_input_postfix">{t("cm_label")}</div>
               </div>
               {mountErr1 && (
                 <h2 className="measure_input_desc measure_input_desc_err">
                   {t("Required field")}
                 </h2>
               )}
               <h2 className="measure_input_desc">
                 <Accordion>
                   <Accordion.Item eventKey="0">
                     <ContextAwareToggleViewDetails
                       eventKey="0"
                       textOnHide={t("Depth Requirements")}
                       textOnShow={t("Hide Details")}
                     />
                     <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                       <div className="basket_item_title_container">
                         <div className="accordion_help">
                           <div className="help_container">
                             <div className="help_multi_select_container">
                               <span
                                 className={`help_column_header ${
                                   depthHelp === "Double Layer"
                                     ? "dk_curtain_symmetric_button_on"
                                     : ""
                                 }`}
                                 onClick={() => {
                                   setDepthHelp("Double Layer");
                                 }}
                               >
                                 {t("Double Layer")}
                               </span>
                               <span
                                 className={`help_column_header ${
                                   depthHelp === "Triple Layer"
                                     ? "dk_curtain_symmetric_button_on"
                                     : ""
                                 }`}
                                 onClick={() => {
                                   setDepthHelp("Triple Layer");
                                 }}
                               >
                                 {t("Triple Layer")}
                               </span>
                             </div>
                             {depthHelp === "Double Layer" && (
                               <div className="help_column help_right_column">
                                 {/*<h6 className="help_column_header">{t("Minimum Depth Required:")}</h6>*/}
                                 <ul className="help_column_list">
                                   <li className="no_listStyle">
                                     {t("Rod & Standard Track")}
                                   </li>
                                   <li className="no_listStyle">{t("25cm")}</li>
                                 </ul>
                                 <ul className="help_column_list">
                                   <li className="no_listStyle">
                                     {t("Rod & Cord Draw Track")}
                                   </li>
                                   <li className="no_listStyle">{t("25cm")}</li>
                                 </ul>
                               </div>
                             )}
                             {depthHelp === "Triple Layer" && (
                               <div className="help_column help_right_column">
                                 {/*<h6 className="help_column_header">{t("Minimum Depth Required:")}</h6>*/}
                                 <ul className="help_column_list">
                                   <li className="no_listStyle">
                                     {t("Rod & Two Standard Track")}
                                   </li>
                                   <li className="no_listStyle">{t("30cm")}</li>
                                 </ul>
                                 <ul className="help_column_list">
                                   <li className="no_listStyle">
                                     {t("Rod & Two Cord Draw Track")}
                                   </li>
                                   <li className="no_listStyle">{t("30cm")}</li>
                                 </ul>
                                 <ul className="help_column_list">
                                   <li className="no_listStyle">
                                     {t("Rod & Standard Track & Cord Draw Track")}
                                   </li>
                                   <li className="no_listStyle">{t("30cm")}</li>
                                 </ul>
                               </div>
                             )}
                           </div>
                         </div>
                       </div>
                     </Accordion.Body>
                   </Accordion.Item>
                 </Accordion>
               </h2>
             </div>
           </div>
           <div className="own_measurements_Length">
             <div className="measure_input_container">
               <h1 className="measure_input_label">{t("MouldingHeight")}</h1>
               <div className="measure_input_field_container">
                 <input
                   ref={(ref) => (inputs.current["mouldingHeight"] = ref)}
                   autoComplete="off"
                   onKeyDown={(e) => {
                     if (e.keyCode === 13) {
                       inputs.current["depth"].focus();
                     } else if (
                       !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                       e.keyCode !== 8 &&
                       e.keyCode !== 46 &&
                       e.keyCode !== 37 &&
                       e.keyCode !== 39 &&
                       e.keyCode !== 13
                     ) {
                       e.preventDefault();
                     }
                   }}
                   className={
                     "measure_input" +
                     ((mouldingHeight !== undefined &&
                       (mouldingHeight < 1 || mouldingHeight > 40)) ||
                     mountErr2
                       ? " measure_input_err"
                       : "")
                   }
                   type="text"
                   name="mouldingHeight"
                   value={NumToFa(`${mouldingHeight || ""}`, pageLanguage)}
                   text={t("Moulding")}
                   ref-num="3A0"
                   onChange={(e) => {
                     let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                     setMouldingHeight(parseInt(newValue));
                     setTimeout(() => {
                       if (
                         newValue &&
                         newValue !== "" &&
                         parseInt(newValue) >= 1 &&
                         parseInt(newValue) <= 40
                       ) {
                         setCartLoading(true);
                         setCart("MouldingHeight", parseInt(newValue));
                         setDeps("", "3A12");
                         setMountErr2(false);
                         if (
                           depth &&
                           depth !== "" &&
                           parseInt(depth) >= 1 &&
                           parseInt(depth) <= 100
                         ) {
                           selectChanged(e);
                           let tempExtended = extendedTitle;
                           tempExtended["3A0"] = [e.target.getAttribute("text")];
                           tempExtended["3A0"][1] = (
                             <li key="1" className="step_title_extended_list_item">
                               <span className="step_title_extended_list_item_title">
                                 {t("Depth")}: {parseInt(depth)}
                                 {t("cm_label")}
                               </span>
                               <span className="step_title_extended_list_item_text">
                                 {t("MouldingHeight")}: {parseInt(newValue)}
                                 {t("cm_label")}
                               </span>
                             </li>
                           );
                           setExtendedTitle(tempExtended);
                         } else {
                           selectChanged(undefined, "3A0");
                           let tempExtended = extendedTitle;
                           tempExtended["3A0"] = [];
                           setExtendedTitle(tempExtended);
                         }
                       } else {
                         setCartLoading(true);
                         // setMouldingHeight(parseInt(newValue));
                         selectChanged("3A0", undefined, t("Invalid Measurements"));

                         setCart("", "", "MouldingHeight");
                         setDeps("3A12", "");
                         let tempExtended = extendedTitle;
                         tempExtended["3A0"] = [];
                         setExtendedTitle(tempExtended);
                       }
                     }, 200);
                   }}
                 />
                 <div className="measure_input_postfix">{t("cm_label")}</div>
               </div>
               {mountErr2 && (
                 <h2 className="measure_input_desc measure_input_desc_err">
                   {t("Required field")}
                 </h2>
               )}
               <h2 className={"measure_input_desc"}>{t("Up to 40cm")}</h2>
             </div>
           </div>
         </div>

         <NextStep
           currentStep="3A0"
           eventKey={
             step3A0 === "Moulding" &&
             (!depth ||
               depth < 1 ||
               depth > 1000 ||
               !mouldingHeight ||
               mouldingHeight < 1 ||
               mouldingHeight > 40)
               ? "3A0"
               : "3"
           }
           onClick={() => {
             setTimeout(() => {
               if (step3A0 === "Moulding") {
                 if (!depth) {
                   setMountErr1(true);
                 }
                 if (!mouldingHeight) {
                   setMountErr2(true);
                 }
               }
             }, 200);
           }}
         >
           {t("NEXT STEP")}
         </NextStep>
       </div>

       <div className="accordion_help">
         <div className="help_container">
           <div className="help_column help_left_column">
             <p className="help_column_header"></p>
             <ul className="help_column_list">
               <li className="no_listStyle">
                 <b>{t("grommet_mount_help1")}</b>
                 {t("grommet_mount_help2")}
               </li>
               <li className="no_listStyle">
                 <b>{t("grommet_mount_help3")}</b>
                 {t("grommet_mount_help4")}
               </li>
               <li className="no_listStyle">
                 <b>{t("grommet_mount_help5")}</b>
                 {t("grommet_mount_help6")}
               </li>
             </ul>
           </div>
         </div>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
